<app-header [menuConfig]="menuConfig" [isSticky]="isHeaderSticky()" (toggleSidenav)="visible.set(true)"
  (changeCreditUnion)="openChangeCreditUnion()"></app-header>

<p-drawer [(visible)]="visible" styleClass="custom-drawer">
  <a routerLink="/" class="flex items-center ml-5" (click)="hideDrawer()">
    <img src="assets/img/logos.jpg" alt="Avana logo" class="h-[42px] block">
  </a>
  <div class="flex flex-col gap-2 mt-5 p-4 bg-Gray-100">
    <p class="font-bold">{{ userProfileData()?.firstName }} {{ userProfileData()?.lastName }}</p>
    @if (creditUnionName()) {
      <p>{{ creditUnionName() }}</p>
    }
    @if (hasMultipleCreditUnions()) {
      <a class="flex items-center gap-2 text-accent-success no-underline cursor-pointer w-fit" (click)="openChangeCreditUnion()">
        <i class="material-symbols-rounded text-brand">sync</i>
        <span>Change credit union</span>
      </a>
    }
  </div>
  <div class="flex flex-col justify-between h-[calc(100vh-200px)]">
    <div>
      @for (item of menuConfig; track item.label) {
        @if (item.path) {
          <div class="flex items-center gap-2 h-12 py-1 px-4 cursor-pointer hover:bg-Gray-200" [routerLink]="item.path" (click)="hideDrawer()">
            <span>{{item.label}}</span>
          </div>
        } @else {
          <div class="flex items-center gap-2 h-12 py-1 px-4">
            <span>{{item.label}}</span>
          </div>
        }
      }
    </div>
    <div class="border border-b-0 border-x-0 border-Gray-400">
      <div class="flex items-center gap-2 h-14 py-1 px-4 cursor-pointer hover:bg-Gray-200" [routerLink]="'/settings'" (click)="hideDrawer()">
        <i class="material-symbols-rounded">settings</i>
        <span>Settings</span>
      </div>
      <div class="flex items-center gap-2 h-14 py-1 px-4 cursor-pointer hover:bg-Gray-200" (click)="logout()">
        <i class="material-symbols-rounded text-accent-red">logout</i>
        <span class="text-accent-red">Logout</span>
      </div>
    </div>
  </div>
</p-drawer>

<main [class]="mainClasses()">
  @if (!areBannersHidden() && (isTopBannerVisible() || isLendingPreferencesVisible())) {
    <div class="relative w-full mx-auto py-4">
      <div class="relative">
        @if (!currentUrl().includes('lending-preferences') && isLendingPreferencesVisible()) {
          <app-lending-preferences-banner 
            [isFirstTime]="isFirstTimeLendingPreferencesSetup()"
            [shouldStack]="shouldStackBanners()" 
            (onRemindMeLater)="onRemindMeLater()">
          </app-lending-preferences-banner>
        }
        @if (isTopBannerVisible()) {
          <app-webinar-banner [shouldStack]="shouldStackBanners()"></app-webinar-banner>
        }
      </div>
      @if (shouldShowAllMessagesLink()) {
        <p class="text-right mt-4 cursor-pointer" (click)="toggleShowAllMessages()">Show all messages</p>
      }
    </div>
  }
  <router-outlet></router-outlet>
</main>

@if (!isFullWidthPage()) {
  <app-footer></app-footer>
}